import request from './request';
import * as account from './account';
import * as images from './images';
import * as products from './products';
import affiliates from './affiliates';
import ai from './ai';
import billing from './billing';
import csv from './csv';
import listings from './listings';
import merge from './merge';
import photoEditor from './photoEditor';
import profiles from './profiles';
import schedule from './schedule';
import shops from './shops';
import studio from './studio';
import user from './user';
import variations from './variations';
import waitlist from './waitlist';

export default {
  ...request,
  account,
  affiliates,
  ai,
  billing,
  csv,
  images,
  listings,
  merge,
  photoEditor,
  products,
  profiles,
  schedule,
  shops,
  studio,
  user,
  variations,
  waitlist,
};
